module.exports = __webpack_public_path__ + "img/06.00373712.png";